import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { UnassignedShift } from '@wilson/interfaces';
import {
  combineLatest,
  debounceTime,
  map,
  Observable,
  shareReplay,
} from 'rxjs';
import { ShiftTimelineUnassignedRegionStateFacadeService } from '../shift-timeline-unassigned-region/shift-timeline-unassigned-region-state-facade.service';
import { ShiftTimelineFilterUnassignedRegionState } from './shift-timeline-filter-unassigned-region.state';

@Injectable({
  providedIn: 'root',
})
export class ShiftTimelineFilterUnassignedRegionStateFacadeService {
  private readonly store = inject(Store);
  private readonly shiftTimelineUnassignedRegionStateFacadeService = inject(
    ShiftTimelineUnassignedRegionStateFacadeService,
  );

  readonly filteredUnassignedShiftsWithoutActivities$: Observable<
    UnassignedShift[]
  > = combineLatest([
    this.shiftTimelineUnassignedRegionStateFacadeService
      .unassignedShiftsWithoutActivities$,
    this.store.select(
      ShiftTimelineFilterUnassignedRegionState.unassignedShiftIds,
    ),
    this.store.select(
      ShiftTimelineFilterUnassignedRegionState.unassignedShiftSearches,
    ),
  ]).pipe(
    debounceTime(10),
    map(
      ([
        unassignedShiftStacksInView,
        unassignedShiftIdsFilter,
        unassignedShiftSearches,
      ]) => {
        return ShiftTimelineFilterUnassignedRegionState.filterUnassignedShift(
          Object.values(unassignedShiftStacksInView),
          unassignedShiftIdsFilter,
          unassignedShiftSearches,
        );
      },
    ),
    shareReplay(1),
  );
}
